// Import Stimulus controllers (already set up)
import "./controllers"

// Import Hotwire (Turbo)
import "@hotwired/turbo-rails"

// --- Bootstrap CSS & JS ---
import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

// --- React Setup ---
import React from "react"
import { createRoot } from "react-dom/client"
import PillNavbar from "./components/PillNavbar.jsx"

// Mount React when Turbo loads a new page
document.addEventListener("turbo:load", () => {
  
  // Mount PillNavbar
  const navbarContainer = document.getElementById("pill-navbar")
  if (navbarContainer) {
    const navbarRoot = createRoot(navbarContainer)
    navbarRoot.render(<PillNavbar />)
  }
})
